import {MsalService} from '@azure/msal-angular';
import {firstValueFrom} from 'rxjs';

/**
 * msal-browser v3 onwards requires initialize() to be awaited before any other MSAL call, and
 * MsalModule.forRoot does not do it. Without this, anything reaching MsalService.instance - for
 * example AuthenticationMsalService.azureLogin calling getAllAccounts - throws
 * "You must call and await the initialize function before attempting to call any other MSAL API".
 *
 * APP_INITIALIZER waits on the returned promise before the app bootstraps, so every later call is
 * safe regardless of how quickly the login route is reached.
 */
export function initializeMsal(msalService: MsalService): () => Promise<void> {
    return () => firstValueFrom(msalService.initialize());
}
